import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Checkbox } from '@wix/design-system';

interface RememberThisDeviceCheckboxProps {
  checked?: boolean;
  onChange: () => void;
}

export const RememberThisDeviceCheckbox: FC<
  RememberThisDeviceCheckboxProps
> = ({ checked, onChange }) => {
  const { t } = useTranslation();
  return (
    <Box width="100%" align="left">
      <Checkbox size="small" checked={checked} onChange={onChange}>
        {t('enter_code.remeber_this_device')}
      </Checkbox>
    </Box>
  );
};
